import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import PageHero from '@/components/feature/PageHero';
import ContactStrip from '@/components/feature/ContactStrip';

const services = [
  {
    icon: 'ri-settings-3-line',
    title: 'Operations Consulting',
    desc: 'Process design, systems selection, and reporting for owner-operated businesses and nonprofit organizations.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Operations Leadership',
    desc: "Serving as an organization's director of operations, with the scope set season by season in a statement of work.",
  },
  {
    icon: 'ri-funds-line',
    title: 'Financial Consulting',
    desc: '',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Web Development & Technology',
    desc: 'Websites, internal tools, and integrations.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Event & Program Management',
    desc: 'Logistics, budgeting, and execution support.',
  },
  {
    icon: 'ri-task-line',
    title: 'Small Project Management',
    desc: '',
  },
];

export default function Consulting() {
  return (
    <main className="min-h-screen">
      <SiteHeader />
      <PageHero
        eyebrow="Penland LLC"
        title="Consulting &"
        titleAccent="Web Development"
        subtitle="Penland LLC provides consulting and web development under its own name, often for the same clients whose books we keep."
        image="https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20flowing%20geometric%20lines%20and%20soft%20gradient%20planes%20in%20deep%20navy%20and%20teal%2C%20minimal%20corporate%20technology%20backdrop%2C%20cinematic%20soft%20lighting%2C%20elegant%20high-end%20editorial%20style&width=1600&height=900&seq=consulting-hero-01&orientation=landscape"
        imageAlt="Abstract geometric composition representing consulting and web development"
        cta={{ label: 'Get in Touch', href: '#contact' }}
      />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="mb-12 md:mb-16">
              <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
                What We Do
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 max-w-3xl leading-tight">
                Services provided
                <span className="italic text-accent-600"> under our own name</span>
              </h2>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
              {services.map((svc, i) => (
                <div
                  key={i}
                  className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/60 hover:border-accent-300/40 hover:-translate-y-1 transition-all flex flex-col"
                >
                  <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                    <i className={`${svc.icon} text-accent-600 text-2xl`} />
                  </div>
                  <h3 className="font-heading text-lg md:text-xl text-primary-950 font-semibold mb-3">
                    {svc.title}
                  </h3>
                  {svc.desc && (
                    <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                      {svc.desc}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center shrink-0">
                  <i className="ri-file-text-line text-secondary-700 text-2xl" />
                </div>
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl text-primary-950 font-semibold mb-3">
                    How engagements work
                  </h2>
                  <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
                    Engagements run on a monthly retainer or a defined statement of work, and
                    the scope is reviewed each season.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactStrip
        email="info@penlandllc.com"
        title="Let's talk about your project"
        description="For consulting, web development, event and program management, or small project management, contact Penland LLC."
      />
      <SiteFooter />
    </main>
  );
}